export const SOF_BOTTOM_SHEET_LAST_SHOW_TIME_STORAGE_KEY =
  'sourceOfFundsBottomSheetLastShowTime';

export const SOF_BOTTOM_SHEET_SHOW_INTERVAL = 1000 * 60 * 60 * 48; // 48 hours
